<template>
  <BaseModalSmall
    testId="fiskaly-error"
    @close="router.push({ name: 'calendar' })"
  >
    <Flex direction="column">
      <img :src="`/img/visual-error-500.svg`">
      <BaseText>{{ $t('register.fiskaly_error_modal.message') }}</BaseText>
    </Flex>
    <template #footer>
      <BaseButton
        @click="$emit('refetch')"
        :loading="loading"
        v-test="'btn-refresh'"
      >
        {{ $t('global.refresh_button') }}
      </BaseButton>
    </template>
  </BaseModalSmall>
</template>

<script
  lang="ts"
  setup
>
import { useRouter } from 'vue-router';

const router = useRouter();

defineProps<{
  loading: boolean;
}>();
defineEmits(['refetch']);
</script>
